import React from 'react';
import { gql } from '@reverbdotcom/commons/src/gql';
import { useMutation } from './useMutation';
import { Input_core_apimessages_BumpKey, arbiter_Interaction_InteractionType } from './gql/graphql';

export const trackBumpInteractionMutation = gql(`
  mutation Core_Track_Bump_Interaction(
    $input: Input_core_apimessages_TrackBumpInteractionRequest
  ) {
    trackBumpInteraction(input: $input) {
      bumpKey {
        key
      }
    }
  }
`);


interface Props {
  interactionType: arbiter_Interaction_InteractionType;
  bumpKey: Input_core_apimessages_BumpKey;
  listingId: string;
}

export function useBumpInteractionTracking({
  interactionType,
  bumpKey,
  listingId,
}: Props): (componentName: string) => void {
  const [didTrackBumpInteraction, setDidTrackBumpInteraction] = React.useState<object>({});
  const [trackBumpInteraction] = useMutation(trackBumpInteractionMutation);

  const bumpInteractionTracking = (componentName: string) => {
    if (!bumpKey?.key) { return; }
    if (didTrackBumpInteraction[componentName]) { return; }

    trackBumpInteraction({
      variables: {
        input: {
          interactionType,
          bumpKey,
          listingId: listingId,
          componentName,
        },
      },
    });

    setDidTrackBumpInteraction((prevState) => {
      return (
        {
          ...prevState,
          [componentName]: true,
        }
      );
    });
  };

  return bumpInteractionTracking;
}
